import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class KeyMapService {

  constructor() { }

 async KeyMapping(data,type) {
    var step = {}
      let res =await this.getKeyMapValues(type)
      res.map(function (ele) {
      if (data[ele.uiKey] || data[ele.uiKey] == null) {
        step[ele.bKey] = data[ele.uiKey] == undefined ? null : data[ele.uiKey];
      }
    });
    return step
  }

  getKeyMapValues(key) {
    switch (key) {
      case "addReceipt":
       let keyMapReceipt = [ 
          { uiKey: "contact", bKey: "partner_id" },
          { uiKey: "listType", bKey: "p_b_id" },
          { uiKey: "p_u_id", bKey: "p_u_id" },
          { uiKey: "ambassador", bKey: "ambassdor_id" },
          { uiKey: "receiptDate", bKey: "receipt_date" },
          { uiKey: "remark", bKey: "remarks" },
          { uiKey: "offering_type", bKey: "offering_type" },
          { uiKey: "refNumber", bKey: "neft_rtg_no" },
          { uiKey: "checkDDNumber", bKey: "dd_cheque_no" },
          { uiKey: "checkDDDate", bKey: "cheque_dd_date" },
          { uiKey: "depositedLocation", bKey: "deposisted_loc" },
          { uiKey: "bankDrawee", bKey: "drawee_bank" },
          { uiKey: "totalAmount", bKey: "total_amount" },
          { uiKey: "transactionDate", bKey: "trans_date" },
          { uiKey: "bank", bKey: "bank_id" },
          { uiKey: "remark", bKey: "remarks" },
          { uiKey: "received", bKey: "payment_mode_id" },
          { uiKey: "medium", bKey: "payment_medium_id" },
          { uiKey: "paymentGateway", bKey: "payment_gateway_id" },
          { uiKey: "transactionDate", bKey: "cash_pay_remarks" },//***** null
          { uiKey: "transactionDate", bKey: "payment_gateway_remarks" },//***** null
          { uiKey: "transactionDate", bKey: "created_by" },//***** null modifiy_by

        ];
        return keyMapReceipt
        case "addReceipt":
          let keyMapCreatePartnerID = [ 
             { uiKey: "title", bKey: "title_id" },
             { uiKey: "listType", bKey: "full_name" }, 
             { uiKey: "listType", bKey: "primary_mobile_no" }, 
             { uiKey: "listType", bKey: "address_line1" }, 
             { uiKey: "listType", bKey: "address_line2" }, 
             { uiKey: "listType", bKey: "address_line3" }, 
             { uiKey: "listType", bKey: "state_id" }, 
             { uiKey: "listType", bKey: "country_id" }, 
             { uiKey: "listType", bKey: "district" }, 
             { uiKey: "listType", bKey: "postal_code" }, 
             { uiKey: "listType", bKey: "city" }, 
             { uiKey: "listType", bKey: "dob" }, 
             { uiKey: "listType", bKey: "sex" }, 
             { uiKey: "listType", bKey: "martial_status" }, 
             { uiKey: "listType", bKey: "education_id" }, 
             { uiKey: "listType", bKey: "language_id" }, 
             { uiKey: "listType", bKey: "occupation" }, 
             { uiKey: "listType", bKey: "wed_date" }, 
             { uiKey: "listType", bKey: "email_id" }, 
             { uiKey: "listType", bKey: "land_line_no" }, 
             { uiKey: "listType", bKey: "alter_phone_no" }, 
             { uiKey: "listType", bKey: "state_name" }, 
             { uiKey: "listType", bKey: "country_name" }, 
           ];
           return keyMapCreatePartnerID  
    }
  }

}
